import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '@core/auth/auth.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { StudentSearchService } from '@app/modules/search/services/student-search.service';
import { IStudentSearchResult, StudentSearchFilter } from '@app/modules/search/model/studentSearchResult';
import { NavigationEnd, Router } from '@angular/router';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatLegacyPaginator as MatPaginator, LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { MatSort } from '@angular/material/sort';
import { ApiResult, PageResult } from '@app/shared/model/apiresult';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { filter } from 'rxjs/operators';


@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css']
})
export class NavBarComponent implements OnInit{
  displayedColumns: string[] = ['institutionId', 'name'];
  dataSource = new MatTableDataSource<IStudentSearchResult>();  
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('input') input: ElementRef;
  isCollapsed = true;  
  studentCount:number;
  public searchFilter: StudentSearchFilter;
  disableInput:boolean=false;
  @Input() ReadApr:boolean=false;
  @Input() ReadCertification:boolean=false;
  @Input() ReadReports:boolean=false;
  @Input() ReadMaintenance:boolean=false;
  @Input() ReadStudentSearch:boolean=false;
  @Input() ReadSummary:boolean=false;
  @Input() ReadDocuments:boolean=false;
  isOpen = false;
  public isHidden: boolean = true;
  constructor(public auth: AuthService,
    private permissionsService: NgxPermissionsService,
    private _studentsearchservice: StudentSearchService,
    private _snackBar: MatSnackBar,
    private router:Router) {
      this.router.events.pipe(filter(e=>e instanceof NavigationEnd)).subscribe((val) =>{
        this.isHidden = (this.router.url == "/student-search");
      })

      this.router.routeReuseStrategy.shouldReuseRoute = function() {
        return false;
      };

   }

   ngOnInit() {
    this.searchFilter={
        pageSize:10,
        page:1,
        sortDirection:0,
        sortOrderBy:"lastName"
    }
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.searchFilter={
      pageSize:event.pageSize,
      page:event.pageIndex+1,
      sortDirection:0,
      sortOrderBy:"lastName",
      name:this.input.nativeElement.value
    }   
    this.getStudents();
  }
  getStudents() {
        this.disableInput =true;   
        this._studentsearchservice.studentSearch(this.searchFilter).
        subscribe((result: ApiResult<PageResult<IStudentSearchResult>>) =>
        {
            this.disableInput=false;
            if (result.validationErrors === null && result.value !== null) {
                this.dataSource = new MatTableDataSource(result.value.items);
                this.studentCount=result.value.count;                
            }
            setTimeout(() => {
                document.getElementById('txtSearch').focus();
            }, 300);
        }, error => console.error(error));
    }  
    
    search()
    {
        this.isOpen=true;
          this.searchFilter={
            pageSize:10,
            page:1,
            sortDirection:0,
            sortOrderBy:"lastName",
          name:this.input.nativeElement.value
        }
        this.getStudents();         
    }
   
    toggleCollapsed(): void {
      this.isCollapsed = !this.isCollapsed;
    }
    
    logout() {
      this.permissionsService.flushPermissions();
      this.auth.logout();
    }  

    view(student:IStudentSearchResult) {
      var module=this.router.url;      
      if(module.includes("compliance")){
         this.router.navigate(['/compliance', ''], { queryParams: {id: student.studentId}});
      }
      else if(module.includes("prospective")){
         this.router.navigate(['/prospective'], { queryParams: {id: student.studentId}});
      }
      else if(module.includes("financialaid")){
         this.router.navigate(['/financialaid'], { queryParams: {id: student.studentId}});
      }
      else{
        this.router.navigate(['/compliance', ''], { queryParams: {id: student.studentId}});
      }
      this.isOpen=false;
      let snackBarRef = this._snackBar.open("Navigate to Institution ID: "+student.institutionId, "Close", {
        duration: 2000,
      });  
    }  
    
  }


